import { element } from 'protractor';
import { DisplayadComponent } from './../displayad/displayad.component';
import { DisplayadData } from './../displayad/displayad-data';
import { Component, OnInit, ɵɵsetComponentScope } from '@angular/core';
import { RateserviceService } from '../services/rateservice.service';
import { AdRate } from '../adrate';
import { Router } from '@angular/router';
import { Globals } from '../Globals';
import { NgForm } from '@angular/forms';
import { Addates3Service, adDate } from '../services/addates3.service';
import { stringify } from 'querystring';
import {formatDate } from '@angular/common';
import { AdDataService } from '../services/addata.service';
import { UserdataService } from '../services/userdata.service';

import * as moment from 'moment';
import { collectExternalReferences } from '@angular/compiler';

declare var $: any;

class displayadModelinf {
  boxcharge: any;
  postalcharge: any;
  adcategory: any;
  location: any;
  choosedAd: any;
  customradio: any;
  basicrate: any;
  widthinput: any;
  heightinput: any;
  adsizeinsqcm: any;
  uploadbtn: any;
  adsize: any;
  adcost: any;
  amount: any;
  adContent: any;
  adContentPreview: any;
  gst: any;
  totalCost: any;
  imagename: string;
  adtype: string;
  adpage: string;
  flagupload: any;
  flagdate: any;
  noofdays: any;
  email: any;
  addate: any;
  trxnid: any;
  fileData: File;
  uploadedFilePath: string;
  selectedDate: any;

    constructor( ) {
      this.postalcharge = null;
      this.boxcharge = null;
      this.adcategory = null;
      this.location = null;
      this.amount = null;
      this.choosedAd = null;
      this.customradio = null;
      this.basicrate = null;
      this.widthinput = null;
      this.heightinput = null;
      this.adsizeinsqcm = null;
      this.uploadbtn = null;
      this.adsize = null;
      this.adcost = null;
      this.adContent = null;
      this.adContentPreview = null;
      this.gst = null;
      this.totalCost = null;
      this.imagename = null;
      this.adtype = null;
      this.adpage = null;
      this.flagupload = null;
      this.flagdate = null;
      this.noofdays = null;
      this.email = null;
      this.addate = null;
      this.trxnid = null;
      this.fileData = null;
      this.uploadedFilePath = null;
      this.selectedDate = null;
  }

}
@Component({
  selector: 'app-datepicker1',
  templateUrl: './datepicker1.component.html',
  styleUrls: ['./datepicker1.component.css']
})
export class Datepicker1Component implements OnInit {
  today = new Date();
  todaysDataTime = '';
  Time: string;
  selectDate: any;
  freedays: number;
  free: any;
  frees: any;
  date: number;
  latest: number;
  maxi: any;


  // datesession(){
  //   sessionStorage.removeItem("selectedDate");
  //   sessionStorage.removeItem(this.selectedDate);



  //     console.log("Date cleared");
  // }


  constructor(private router: Router, public globals: Globals, private addata: AdDataService,
              private userdataservice: UserdataService) {

                this.todaysDataTime = formatDate(this.today, 'dd-MM-yyyy HH:mm:ss ', 'en-US', '+0530');
                this.Time = formatDate(this.today, 'dd-MM-yyyy 17:00:00 ', 'en-US', '+0530');
                console.log(this.Time);
                console.log(this.todaysDataTime);

  }
  displayadModel = {
    boxcharge: null,
    postalcharge: null,
    adcategory: null,
    location: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    uploadbtn: null,
    adsize: null,
    adcost: null,
    amount: null,
    adContent: null,
    adContentPreview: null,
    gst: null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noofdays: null,
    email: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,
    selectedDate: null,
    touched: null,
    freedays: null,
    free: null,
    frees: null,
  };

  adDetails = {
    boxcharge: '',
    postalcharge: '',
    location: '',
    free: '',
    frees: '',
    freedays: '',
    adcategory: '',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    uploadbtn: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    amount: '',
    gst: 0,
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '2nd Page',
    noofdays: '',
    email: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',
    selectedDate: [] = '',
    touched: ''
  };

  selectedDate: any = [];
  noOfAdDays: any = [];

  noofdays: any = [];

  cost: number;
  amount: any;
  rate: any;
  temp: any;
  user: any;



  public adDatesTemp: any[] = [
    {
      id: '',
      advtDate: ''
    }
  ];


  ngOnInit() {



    this.user = this.userdataservice.getUserData();

    this.displayadModel = this.adDetails;


    this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));


    const obj1 = this.addata.getAdData();
    this.displayadModel = (obj1) ? obj1 : this.adDetails;
    console.log(obj1);

    if (this.displayadModel['noOfAdDays']) {
      this.bootstrapDateoptions(parseInt(this.displayadModel['noOfAdDays'], 10));
    }

    if (sessionStorage.getItem('selectedDate')) {
      this.selectedDate = sessionStorage.getItem('selectedDate');
      this.selectedDate = this.selectedDate.split(',');
      // $('#Txt_Date').datepicker('setDate', this.selectedDate);
      // $('#Txt_Date').datepicker('update');
      // $('#Txt_Date').val('');
    }
    // this.bootstrapDateoptions(5);
  }

  clickdp() {
    $('#Txt_Date').focus();
  }


  bootstrapDateoptions(limit) {
    console.log(limit);
    const self = this;
    if (this.todaysDataTime < this.Time) {
      console.log('book ad');
      $('#Txt_Date').datepicker({
        format: 'dd-mm-yyyy',
        inline: false,
        lang: 'en',
        step: limit,
        multidate: limit,
        minDate: null,
        closeOnDateSelect: true,
        startDate: '+1d',

      });
    } else {
      console.log('tmrw');
      $('#Txt_Date').datepicker({
        format: 'dd-mm-yyyy',
        inline: false,
        lang: 'en',
        step: limit,
        multidate: limit,
        minDate: null,
        closeOnDateSelect: true,
        startDate: '+2d',

      });
    }

    //   $(document).ready(function(){
    //     $("Txt_Date").datepicker();
    $('#Txt_Date').datepicker('update', '');
    // });
    $('#dp3').datepicker().on('changeDate', (ev) => {
      $('#Txt_Date').change();
      console.log('Txt_Date');
    });
    $('#Txt_Date').val('dd-mm-yyyy');
    $('#Txt_Date').change(() => {

      const selectedDate = $('#Txt_Date').val();
      // this.selectedDate = selectedDate.split(',');
      self.dateChange(selectedDate);
      //  console.log(this.selectedDate);
    });
    if (this.displayadModel.selectedDate) {
      const ar = (this.displayadModel.selectedDate.includes(',')) ? this.displayadModel.selectedDate.split(',')
        : this.displayadModel.selectedDate;

      $('#Txt_Date').datepicker('setDate', ar);
    } else {
      $('#Txt_Date').datepicker('setDate', null);
    }
  }

  dateChange(value) {

    if (value) {

      console.log(value);
      this.globals.adDateCounter++;
      console.log(this.globals.adDateCounter);
      console.log(this.globals.adDateCounter, this.globals.adDates);
      // if (this.globals.adDateCounter <= this.globals.adDays) {
      this.selectDate = value.split(',');

      this.selectedDate = this.selectDate.sort((addate1, addate2) => {
        addate1 = addate1.split('-'), addate2 = addate2.split('-');
        const day1 = parseInt(addate1[0], 10);
        const day2 = parseInt(addate2[0], 10);
        const month1 = parseInt(addate1[1], 10);
        const month2 = parseInt(addate2[1], 10);
        const year1 = parseInt(addate1[2], 10);
        const year2 = parseInt(addate2[2], 10);

        if (year1 !== year2) {
          return year1 - year2;
        } else if (month1 !== month2) {
          return month1 - month2;
        } else {
          return day1 - day2;
        }

      });

      this.checkforfreedays();
      console.log(this.selectedDate, this.displayadModel.freedays);
      this.maxi = (this.selectedDate);
      this.maxi.reverse();
      this.latest =  this.maxi[0];
      console.log(this.latest);
      this.maxi.reverse();
      console.log(this.selectedDate, this.displayadModel.freedays, this.latest);

      if ( this.displayadModel.freedays === 1) {
        var startdate = this.latest;
        var new_date = moment(startdate, 'DD-MM-YYYY').add('days', 1);
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');
        this.displayadModel.free = day + '-' + month + '-' + year;
        console.log(new_date, this.displayadModel.free );
        console.log(this.selectedDate, this.displayadModel.freedays, this.displayadModel.free );
      }
      if ( this.displayadModel.freedays === 2) {
        var startdate = this.latest;
        var new_date = moment(startdate, 'DD-MM-YYYY').add('days', 1);
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');
        this.displayadModel.free  = day + '-' + month + '-' + year;
        var startdates = this.displayadModel.free ;
        var new_date = moment(startdates, 'DD-MM-YYYY').add('days', 1);
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');
        this.frees = day + '-' + month + '-' + year;
        console.log(new_date, this.displayadModel.free );
        this.displayadModel.frees = this.frees ;
        console.log(this.selectedDate, this.displayadModel.freedays, this.displayadModel.free, this.displayadModel.frees);

      }
     }
  }



  checkforfreedays() {
    this.displayadModel.freedays = 0;
    if (this.selectedDate.length >= 3) {
      let index = 0;

      while (index <= (this.selectedDate.length - 3)) {
        const date = moment(this.selectedDate[index], 'DD-MM-YYYY');
        const today = date.format('DD-MM-YYYY');
        const tom = date.add(1, 'days').format('DD-MM-YYYY');
        const dayaftom = date.add(1, 'days').format('DD-MM-YYYY');
        // const free = date.add(1,'days').format('DD-MM-YYYY');
        console.log(today, tom, dayaftom);

        const tomexist = this.selectedDate.includes(tom);
        const dayaftomexist = this.selectedDate.includes(dayaftom);
        console.log(today, tom, dayaftom);
        if (tomexist && dayaftomexist) {
          this.displayadModel.freedays++;
          console.log('consecutive days', this.displayadModel.freedays);
          index += 3;
        } else {
          index++;
        }
      }
    }
  }

  pay() {

    if (this.user != null) {
      this.router.navigate(['/adsummary1']);
    } else {
      this.router.navigate(['/adsummary1']);
    }
  }
  adamountCalc() {

    if (this.noOfAdDays) {
      this.temp = this.noOfAdDays;
      this.displayadModel.amount = this.temp * this.displayadModel.adcost;
    }

  }

  // delete(val) {
  //   console.log(val);
  //   if(this.selectedDate.length == this.noOfDays){
  //     this.selectedDate.shift();
  //     this.selectedDate.push(val);
  //   }
  // this.globals.adDateCounter--;
  // this.selectedDate.forEach((element, index) => {
  //   if (element == val) {
  //     this.selectedDate.splice(index, 1);
  //     console.log(this.selectedDate.toString());
  //     $('#Txt_Date').datepicker({
  //       defaultDate: this.selectedDate.toString()
  //     });
  //      $("#Txt_Date").datepicker("update",this.selectedDate.toString());
  //   }
  // });
  // }


  noOfDays(days: number) {
    $('#Txt_Date').datepicker('destroy');
    this.globals.adDays = days;
    this.noOfAdDays = days;
    this.globals.adDates = null;
    this.globals.adDateCounter = 0;
    $('#Txt_Date').val(' ');
    $('#Txt_Date').val(0);
    // window.alert('hai');
    this.selectedDate.length = null;
    this.globals.adDates_temp = null;
    this.globals.adDates = new Array(days);
    this.globals.adDates_temp = new Array(days);
    console.log(this.noOfAdDays);
    /* for (let i: any = 0; i < days; i++) {
    this.globals.adDates[i] = i;
  } */
    this.bootstrapDateoptions(parseInt(this.noOfAdDays, 10));
    this.checkforfreedays();
  }
  getDate() {
    // console.log(this.selectedDate);
    this.freedays = this.displayadModel.freedays;
    this.free = this.displayadModel.free;
    this.frees = this.displayadModel.frees;
    if (this.freedays === 0) {
    sessionStorage.setItem('selectedDate', this.selectedDate.toString());
    sessionStorage.setItem('noOfAdDays', this.noOfAdDays.toString());
    sessionStorage.setItem('freedays', this.freedays.toString());
}
    if (this.freedays === 1) {
      sessionStorage.setItem('selectedDate', this.selectedDate.toString());
      sessionStorage.setItem('noOfAdDays', this.noOfAdDays.toString());
      sessionStorage.setItem('free',  this.free.toString());
      sessionStorage.setItem('freedays', this.freedays.toString());
      }
    if (this.freedays === 2) {
        sessionStorage.setItem('selectedDate', this.selectedDate.toString());
        sessionStorage.setItem('noOfAdDays', this.noOfAdDays.toString());
        sessionStorage.setItem('free', this.free.toString());
        sessionStorage.setItem('frees', this.frees.toString());
        sessionStorage.setItem('freedays', this.freedays.toString());
      }
    sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

    let obj = this.addata.getAdData();
    obj = this.displayadModel;
    this.addata.setAdData(obj);


    // const obj1=this.addata.getAdData();
    // obj.noOfAdDays=this.displayadModel.noofdays;
    // this.addata.setAdData(obj1);

  }

  adDateList(id) {
    // window.alert(current_Date);
    const dateChoosen = (document.getElementById(id) as HTMLInputElement).value;
    console.log(dateChoosen);
    const dateCtrlId = id.substring(2, 4);
    console.log(dateCtrlId);
    this.globals.adDates_temp[dateCtrlId] = dateChoosen;
    /*  this.globals.adDates_temp.push({
      id: date_ctrl_id,
      advtDate: date_choosen
    }); */
  }

  // ListofDates() {
  //   for (let i: any = 0; i < this.globals.adDays; i++) {
  //     console.log(this.globals.adDates_temp[i]);
  //   }
  // }

  // window.alert(this.globals.adDates[this.globals.adDateStored]);

  // this.globals.adDateStored += 1;

}
